import { INDENT } from '@yme/tokens/sizes';
export const GALLERY_CONFIG = {
    isControlsAvailable: true,
    isSquareRatio: false,
    isExpandAvailable: false,
    thumbnailsAmount: {
        desktop: 7,
        smallDesktop: 7,
        tablet: 7,
        mobile: 4,
    },
    thumbnailsIndent: {
        desktop: INDENT.xs,
        smallDesktop: INDENT.xs,
        tablet: INDENT.xs,
        mobile: INDENT.xs,
    },
};
